import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { RouterModule } from "@angular/router";
import { AuthGuard } from "../auth-guard.service";
import { AccountGuard } from "../account-guard.service";
import { PumpLocatorComponent } from "./pumplocator.component";


@NgModule({
  imports:[      
      RouterModule.forChild([
          {path:'pumplocator',component: PumpLocatorComponent, canActivate:[AuthGuard,AccountGuard]}
      ])
    ],
    exports: [
        
    ],
    declarations: [
        PumpLocatorComponent
    ],
    providers: [        
        
    ]
})
export class PumpLocatorModule{

}



// WEBPACK FOOTER //
// ./src/app/pumplocator/pumplocator.module.ts